module.exports = __webpack_public_path__ + "img/1x.07f68d1.jpg";